import PropTypes from 'prop-types'

import { userDetailsPropType } from '../../users/prop-types'

const menuCurationTaskTimestampsPropType = PropTypes.shape({
  autoeatUpdatedAt: PropTypes.string,
  autoeatUpdateAppliedAt: PropTypes.string,
  tierOneDoneAt: PropTypes.string,
  tierOneDoneBy: userDetailsPropType,
  curatedAt: PropTypes.string,
  qadAt: PropTypes.string,
  qcdAt: PropTypes.string,
  curatedBy: userDetailsPropType,
  qadBy: userDetailsPropType,
  qcdBy: userDetailsPropType,
  lastManualUpdateAt: PropTypes.string,
  tierOneCuratorAssignedAt: PropTypes.string,
  unknownWordsCuratorAssignedAt: PropTypes.string,
  unknownWordsQaAssignedAt: PropTypes.string,
  curatorAssignedAt: PropTypes.string,
  qaAssignedAt: PropTypes.string,
  qcAssignedAt: PropTypes.string,
  unknownWordsCuratedAt: PropTypes.string,
  unknownWordsQadAt: PropTypes.string,
  lastManualUpdateBy: userDetailsPropType,
  unknownWordsCuratedBy: userDetailsPropType,
  unknownWordsQadBy: userDetailsPropType,
  latestTierOneDoneDishCount: PropTypes.number,
  latestCuratedDishCount: PropTypes.number,
  latestQadDishCount: PropTypes.number,
  latestQcdDishCount: PropTypes.number,
  latestCuratedUnknownWordCount: PropTypes.number,
  latestQadUnknownWordCount: PropTypes.number,
})

export default menuCurationTaskTimestampsPropType
